module.exports = __webpack_public_path__ + "img/Group 2217.c0d53c94.svg";